import React from 'react';
export function Footer() {
  return <footer className="bg-ink py-8 text-center px-4" data-id="element-122" data-mp="32wd2qgad7ltj">
      <div className="max-w-4xl mx-auto" data-id="element-123" data-mp="3gfsnyg23r0ok">
        <p className="text-cream-dark text-sm" data-id="element-124" data-mp="3ggu1cr6lbz9g">
          © {new Date().getFullYear()} Hip Hop Dance Instructor Ready — All
          rights reserved.
        </p>
      </div>
    </footer>;
}